import { useStore } from "./useStore"

const useLogTransaction = () => {
    const { state } = useStore();
    const actionCodePrefix = "BSS";
    const userTypeCode = state.form?.IsAgent ? 'A' : 'B';

    const getWebActionCode = (type) => {
        let actionCode = ""
        switch (type) {
            case 'attach':
                actionCode = `${actionCodePrefix}Att`;
                actionCode = `${actionCode}${state.borrower.IsMortgage ? 'Non' : 'Std'}${userTypeCode}`
                break;
            case 'insurance':
                actionCode = `${actionCodePrefix}SubIns${userTypeCode}`;
                break;
            default:
                actionCode = `${actionCodePrefix}Att`;
                break;
        }
        return actionCode;
    }
    const getContractCode = () => {

        if (state.borrower.IsVehicle) {
            return "3";
        } else if (state.borrower.IsMortgage) {
            return "2";
        } else {
            return "0";
        }
    }

    const getAdditionalInfo = (data) => {
        const additonalInfo = [];
        additonalInfo.push("Email:" + state.form.PolicyholderEmailAddress);
        if (data.files && data.files.length > 0)
            additonalInfo.push("Files:" + data.files.join(','))

        return additonalInfo.join(';');
    }

    const getLogRequest = async (data) => {
        return {
            LenderCode: state.borrower.LenderCode,
            UserType: state.borrower.IsAgent ? 'Agent' : 'Borrower',
            WebActionCode: getWebActionCode(data.type),
            ContractCode: getContractCode(),
            LoanNumber: state.borrower.LoanNumber,
            LockId: 1,
            LoanId: state.borrower.LoanID,
            ReferenceId: state.borrower.ReferenceID ? state.borrower.ReferenceID : null,
            CoverageId: state.borrower.RequiredCoverageID,
            CollateralId: state.borrower.CollateralID,
            PropertyId: state.borrower.PropertyID,
            Status: "Success",
            AddlInfo: getAdditionalInfo(data)
        };
    }
    const LogTransaction = async (data) => {

        const logRequest = await getLogRequest(data);
        await fetch(`${process.env.GATSBY_API_URL}/log-webusage`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(logRequest),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log('Success:', data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    return {
        LogTransaction
    }
}

export { useLogTransaction }